module.exports = __webpack_public_path__ + "img/seaPalace.263322a6.jpg";